import { DepartmentItem } from 'store/settings/department/model'

export const validateForm = (values: DepartmentItem) => {
  const { name, prepress_category_code } = values

  return !!(name?.trim() && prepress_category_code)
}
